import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DialogModel } from '../../models/shared.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {
    cancelForm!: FormGroup;
    public reasons: string[] = [];
    public reason: string = "";
    constructor(private fb: FormBuilder,
        public dialogRef: MatDialogRef<AlertDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogModel) {
        this.cancelForm = this.fb.group({
            reason: ["", Validators.required] // default selected
        });
        this.reasons = data.list;
    }

    onNoClick(): void {
        this.dialogRef.close(true);
    }

    onCancelClick(): void {
        this.dialogRef.close({ value: true, reason: this.reason });
    }

    onLeaveClick(): void {
        this.dialogRef.close();
    }
    contactSupport() {
        window.location.href = 'mailto:info@sopago.agency';
    }
    reasonChanged($event: any) {
        this.reason = $event.value;
    }
}
